package com.rainbowclubs.rainbow

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import com.rainbowclubs.rainbow.di.initKoin
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // Initialize Koin
    initKoin()

    ComposeViewport {
        Firebase.initialize(
            // TODO Move this to EV
            options = FirebaseOptions(
                applicationId = "1:450027198707:web:eedde75c5ac4edb1f27f86",
                apiKey = "AIzaSyCEkeAdlKcojRy39RVnfx_sFJ9ovANHlfU",
                projectId = "rainbowquest-30604",
            )
        )
        App()
    }
}